<app-wysiwyg
  #Editor
  [minHeight]="true"
  [value]="quote().getHtmlContent()"
  (valueChanged)="contentChanged($event)"
>
</app-wysiwyg>

<form [formGroup]="priceForm" class="price-form">
  <div class="row">
    <div class="form-group col-sm-4">
      <label for="netPrice">Net price</label>
      <input
        pInputText
        id="netPrice"
        formControlName="netPrice"
        type="number"
        step="0.5"
        class="form-control form-control--gray"
      />
    </div>
    <div class="form-group col-sm-4">
      <label for="margin">Margin</label>
      <input
        pInputText
        id="margin"
        formControlName="margin"
        type="number"
        step="0.5"
        class="form-control form-control--gray"
      />
    </div>
    <div class="form-group col-sm-4">
      <label for="total">Total</label>
      <div class="total-with-currency">
        <input
          pInputText
          id="total"
          formControlName="total"
          type="number"
          step="0.5"
          class="form-control form-control--gray"
        />
        <app-currency-select
          [currency]="quote().getCurrency()"
          (currencyChange)="currencyChanged($event)"
        >
        </app-currency-select>
      </div>
    </div>
  </div>
</form>
